
import { Placement } from '@post-office/placements-frontend/jsm-live-chat-notifications';
export default Placement;
